/**
 * Image PropTypes
 *
 * PropType definitions for image objects, product images, and media-related components.
 * Handles various image formats and structures used throughout the application.
 *
 * @module propTypes/image
 */

import PropTypes from "prop-types";

/**
 * Image object shape
 * Represents a structured image object with URL
 *
 * @property {string} url - Image URL (can be relative or absolute)
 */
export const imageObjectShape = PropTypes.shape({
  url: PropTypes.string,
});

/**
 * Flexible image type
 * Accepts either a string URL or an image object
 */
export const imageType = PropTypes.oneOfType([PropTypes.string, imageObjectShape]);

/**
 * Product image array shape
 * Array of product images (string URLs or objects)
 */
export const productImageArrayShape = PropTypes.arrayOf(imageType);
